import {
  AdgroupFormData,
  CampaignFormData,
  SavedAudienceSupportedKeys,
  SavedAudienceFormData,
  DEFAULT_SAVED_AUDIENCE_ID,
} from '@tt4b/ttam-enums';
import { Ref, ref, computed } from '@vue/composition-api';
import { useStdTargetingIs, useSavedAudienceCreateBffApi, useStore, NetStateEnum } from '@tt4b/ttam-hooks';
import { pick } from 'lodash-es';
import TargetSummary from '../target-summary';
import { queryToJson } from '@tt4b/ttam-utils';

export function usePropsSavedAudienceVisible(options: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
}) {
  const { adgroupData, campaignData } = options;
  const { isSupportSavedAudience } = useStdTargetingIs({
    adgroupFormData: adgroupData,
    campaignFormData: campaignData,
  });
  const isSavedAudienceVisible = computed(
    () => isSupportSavedAudience.value && adgroupData.value.savedAudienceId === DEFAULT_SAVED_AUDIENCE_ID,
  );
  return {
    isSavedAudienceVisible,
  };
}

export function useSavedAudienceCreate(props: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
}) {
  const { adgroupData } = props;

  function manageSavedAudience() {
    const { aadvid } = queryToJson();
    const link = `${location.origin}/i18n/dmp/adver/main?aadvid=${aadvid}`;
    window.open(link, '_blank');
  }

  async function handleSavedAudienceCreate(savedAudienceName: string) {
    const formData: SavedAudienceFormData = {
      name: savedAudienceName,
      audience: pick(adgroupData.value, SavedAudienceSupportedKeys),
    };
    try {
      const result = await useSavedAudienceCreateBffApi(formData);
      return {
        savedAudienceFull: result?.saved_audience_full,
        savedAudienceId: result?.saved_audience_id,
        success: true,
      };
    } catch (error) {
      return {
        success: false,
      };
    }
  }

  async function handleSavedAudienceSuccess() {
    const { getStore } = useStore();
    const { run: loadData } = getStore(NetStateEnum.savedAudienceList);
    await loadData();
  }
  return {
    handleSavedAudienceCreate,
    manageSavedAudience,
    handleSavedAudienceSuccess,
  };
}

export function useSavedAudienceDetailData(props: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
  targetSummaryData?: any;
}) {
  const { adgroupData, campaignData, targetSummaryData } = props;
  const savedAudienceDetails = ref();
  function generateSavedAudienceDetails() {
    let detailData = targetSummaryData.value;
    if (!Object.values(detailData).length) {
      const { targetSummaryData: _targetSummaryData } = TargetSummary.usePropsTargetSummaryData({
        campaignData,
        adgroupData,
      });
      detailData = _targetSummaryData.value;
    }

    function _filter(list) {
      return list.filter(item => item?.keys && item.keys?.some(key => SavedAudienceSupportedKeys.includes(key)));
    }

    return {
      showData: _filter(detailData.showData),
      noLimitData: _filter(detailData.noLimitData),
    };
  }

  function handleClickSavedButton() {
    savedAudienceDetails.value = generateSavedAudienceDetails();
  }

  return {
    generateSavedAudienceDetails,
    handleClickSavedButton,
    savedAudienceDetails,
  };
}
